(function () {
  'use strict';

  const copyButton = document.getElementById('js-urlCopy');
  const toast = document.getElementById('js-copyMessage');

  const showToast = (message) => {
    if (!toast) return;

    toast.textContent = message;
    toast.classList.add('is-visible');

    // 一度表示されたら2秒後に非表示に
    setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2000);
  };

  copyButton?.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(location.href);
      showToast('URLをコピーしました');
    } catch (err) {
      console.error('コピーに失敗しました:', err);
      showToast('コピーに失敗しました');
    }
  });
})();